<template>
  <footer>
    <div class="footer-menu-link" @click="navigateTo(menus[0].href)">
      <a>{{ menus[0].title }}</a>
    </div>
    <div class="footer-menu-link" @click="navigateTo(menus[1].href)">
      <a>{{ menus[1].title }}</a>
    </div>
  </footer>
</template>

<script setup>
const menus = [
  {
    title: 'Terms Service',
    href: '/bot/terms'
  },
  {
    title: 'Privacy Policy',
    href: '/bot/privacy'
  }
]
</script>

<script>
export default {
  name: 'FooterBar',
  methods: {
    navigateTo(routerPath) {
      this.$router.push(routerPath);
    }
  }
}
</script>

<style scoped>
.dot {
  color: var(--primary);
}

a {
  color: var(--footer-color-link);
}

footer {
  --footer-height: 300px;
  left: 0;
  display: flex;
  align-items: flex-end;
  min-height: var(--footer-height);
  justify-content: center;
  gap: 1rem;
}

.bot-name {
  font-size: 18px;
  display: flex;
  align-items: center;

  svg {
    padding-right: 10px;
  }

  :hover {
    cursor: pointer;
  }
}

.navbar {
  padding: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-menu-link {
  text-align: center;
  margin-bottom: 5px;
}

@media (max-width: 768px) {
  footer {
    --footer-height: 200px;
    flex-direction: column;
    align-items: center;
    padding: 1rem;
    gap: 0.5rem;
  }

  .footer-menu-link {
    margin-bottom: 0;
  }

  .footer-menu-link a {
    font-size: 0.9rem;
  }
}
</style>
